import moment from 'moment-timezone';

const getDateForCurrentTimeZone = (date: string): string =>
    moment.tz(date, 'UTC').clone().tz('America/New_York').format('h:mm A MM/DD/YYYY');

export default getDateForCurrentTimeZone;
